// extracted by mini-css-extract-plugin
export default {"wrap":"consultationsUserArchive_wrap__ZAn6c"};